module.exports = __webpack_public_path__ + "img/pic_18.c59582de.jpg";